import { defineMessages } from "./define.js";

/** The map: a place, what was thought of it, and the ways one gets added. */
export const places = defineMessages("places", {
  title: { ru: "Места", en: "Places" },
  subtitle: {
    ru: "Куда сходить и куда вернуться.",
    en: "Where to go, and where to go back to.",
  },
  empty: {
    ru: "Карта пустая. Добавьте первое место — долгим нажатием по карте или поиском.",
    en: "The map is empty. Add the first place — press and hold the map, or search.",
  },
  emptyFiltered: {
    ru: "В этом списке пока ничего нет.",
    en: "Nothing in this list yet.",
  },

  /* Фильтры списка: «куда собирались» и «где понравилось» — разные списки. */
  filterAll: { ru: "Все", en: "All" },
  filterTodo: { ru: "Ещё не были", en: "Not been" },
  filterVisited: { ru: "Были", en: "Been" },
  filterRated: { ru: "Оценка", en: "Rated" },
  byDistance: { ru: "Ближе всего", en: "Nearest" },

  /* Переключатель поверх экрана: карта или тот же набор строк списком. */
  viewMap: { ru: "Карта", en: "Map" },
  viewList: { ru: "Список", en: "List" },

  /* ------------------------------------------------------------ добавление */

  add: { ru: "Новое место", en: "New place" },
  addHere: { ru: "Добавить здесь", en: "Add here" },
  titleLabel: { ru: "Название", en: "Name" },
  titlePlaceholder: { ru: "Как называется", en: "What it's called" },
  addressLabel: { ru: "Адрес", en: "Address" },
  addressPlaceholder: { ru: "Улица, дом", en: "Street, number" },
  noteLabel: { ru: "Заметка", en: "Note" },
  notePlaceholder: {
    ru: "Что заказать, когда лучше приходить",
    en: "What to order, when to come",
  },
  urlLabel: { ru: "Ссылка", en: "Link" },
  coordinatesLabel: { ru: "Координаты", en: "Coordinates" },
  coordinatesBroken: {
    ru: "Не похоже на пару «широта, долгота»",
    en: "That does not read as «latitude, longitude»",
  },
  /* Место обычно находят в другом приложении: ссылку скопировали в картах,
     переключились сюда — и дальше долгое нажатие и системное меню. */
  pasteLink: { ru: "Вставить ссылку", en: "Paste the link" },
  pasteHint: {
    ru: "Ссылка из Яндекс.Карт или Google Карт — точка встанет сама",
    en: "A link from Yandex or Google Maps — the pin places itself",
  },
  linkHasNoPoint: {
    ru: "В этой ссылке нет координат — поставьте точку на карте",
    en: "No coordinates in that link — place the pin yourself",
  },
  search: { ru: "Найти место", en: "Find a place" },
  searchAction: { ru: "Найти", en: "Search" },
  searchPlaceholder: { ru: "Название или адрес", en: "Name or address" },
  searchEmpty: { ru: "Ничего не нашлось", en: "Nothing found" },
  searchFailed: {
    ru: "Поиск не отвечает. Точку можно поставить руками.",
    en: "Search is not answering. You can place the pin by hand.",
  },
  /* Подпись под полем поиска: единственное место в приложении, где запрос
     уходит наружу, и человек имеет право знать об этом заранее. */
  searchLeaves: {
    ru: "Запрос уходит в OpenStreetMap. Всё остальное остаётся здесь.",
    en: "The query goes to OpenStreetMap. Everything else stays here.",
  },
  dropPin: { ru: "Поставить точку", en: "Drop a pin" },
  dropPinHint: {
    ru: "Долгое нажатие по карте ставит точку",
    en: "Press and hold the map to drop a pin",
  },
  useMyLocation: { ru: "Я здесь", en: "I'm here" },
  /* Четыре разных ответа, потому что и делать в них надо разное. */
  locationDenied: {
    ru: "Доступ к геолокации закрыт — разрешите его для сайта",
    en: "Location is blocked — allow it for this site",
  },
  /* Разрешение выдано, а браузер всё равно отказал: значит, запрещено самим
     сайтом, и в настройках человеку делать нечего. */
  locationBlocked: {
    ru: "Геолокация выключена самим приложением — это не ваши настройки",
    en: "The app itself has location switched off — not your settings",
  },
  locationUnavailable: {
    ru: "Телефон не смог определить место. Включена ли геолокация в системе?",
    en: "The phone could not get a fix. Is location switched on?",
  },
  locationSlow: {
    ru: "Ответа так и не дождались — попробуйте ещё раз",
    en: "No answer in time — try again",
  },
  locationUnsupported: {
    ru: "Этот браузер не сообщает, где вы",
    en: "This browser does not report where you are",
  },

  /* ----------------------------------------------------------------- карточка */

  notVisited: { ru: "Ещё не были", en: "Not been yet" },
  visited: { ru: "Были", en: "Been" },
  markVisited: { ru: "Отметить, что были", en: "Mark as visited" },
  markNotVisited: { ru: "Всё-таки не были", en: "Not been after all" },
  route: { ru: "Маршрут", en: "Directions" },
  /* Открывает карты телефона: у них живые пробки и голос, а у нас — нет. */
  routeHint: {
    ru: "Откроется в картах телефона",
    en: "Opens in the phone's map app",
  },
  discuss: { ru: "Обсудить", en: "Discuss" },
  photos: { ru: "Фотографии", en: "Photos" },
  addPhoto: { ru: "Добавить фотографию", en: "Add a photo" },
  editPlace: { ru: "Изменить место", en: "Edit place" },
  removePlace: { ru: "Удалить место", en: "Delete place" },
  removeConfirm: {
    ru: "Удалить это место? Отзывы и фотографии уйдут вместе с ним.",
    en: "Delete this place? The reviews and photos go with it.",
  },
  addedBy: { ru: "Добавил(а) {name}", en: "Added by {name}" },

  /* ------------------------------------------------------------------ отзыв */

  rating: { ru: "Оценка", en: "Rating" },
  yourRating: { ru: "Ваша оценка", en: "Your rating" },
  rate: { ru: "Оценить", en: "Rate it" },
  rateStars: { ru: "{count} из 5", en: "{count} out of 5" },
  reviewLabel: { ru: "Отзыв", en: "Review" },
  reviewPlaceholder: {
    ru: "Как оно было",
    en: "How it was",
  },
  saveReview: { ru: "Сохранить", en: "Save" },
  removeReview: { ru: "Убрать оценку", en: "Remove the rating" },
  noReviews: { ru: "Никто ещё не оценивал", en: "Nobody has rated it yet" },
  /* Средняя из двух оценок — это несогласие, и округлять его нечестно. */
  averageOf: { ru: "средняя из {count}", en: "average of {count}" },

  /* ----------------------------------------------------------------- рядом */

  nearby: { ru: "Рядом с вами", en: "Near you" },
  nearbyOne: { ru: "Рядом одно место", en: "One place near you" },
  /* Расстояние словами: «200 м» читается быстрее, чем «0.2 км». */
  metres: { ru: "{count} м", en: "{count} m" },
  kilometres: { ru: "{count} км", en: "{count} km" },
  nearbyHint: {
    ru: "Считается на телефоне: где вы — не уходит никуда.",
    en: "Worked out on the phone: where you are goes nowhere.",
  },
  locate: { ru: "Показать, где я", en: "Show where I am" },

  /* ----------------------------------------------------------- уведомление */

  notifyAdded: { ru: "{name}: новое место", en: "{name}: a new place" },

  /* ------------------------------------------------------------------ карта */

  mapMissing: {
    ru: "Карта не загрузилась. Места ниже — списком.",
    en: "The map did not load. The places are listed below.",
  },
  mapLoading: { ru: "Карта загружается", en: "Loading the map" },
  /* Подложка покрывает регион, а не планету. За его краем рисовать нечего —
     и это граница, которую выбрали, а не поломка. */
  outsideRegion: {
    ru: "Здесь карта не загружена — за пределами скачанного региона",
    en: "No map here — outside the downloaded region",
  },
  zoomIn: { ru: "Приблизить", en: "Zoom in" },
  zoomOut: { ru: "Отдалить", en: "Zoom out" },
});
